



































































































































































































































































































import {getDicts} from '@/api/system/dict/data';
import {addPost, delPost, getPost, listPost, updatePost} from '@/api/system/post';
import {api} from '@/plugins/api';
import {msgSuccess} from '@/plugins/element';
import {download, selectDictLabel} from '@/utils/ruoyi';
import {ElForm} from 'element-ui/types/form';
import Vue from 'vue';

export default Vue.extend({
  name: 'Post',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      postList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined
      },
      // 表单参数
      form: {} as any,
      // 表单校验
      rules: {
        postName: [
          {required: true, message: '岗位名称不能为空', trigger: 'blur'}
        ],
        postCode: [
          {required: true, message: '岗位编码不能为空', trigger: 'blur'}
        ],
        postSort: [
          {required: true, message: '岗位顺序不能为空', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getList();
    getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data;
    });
  },
  methods: {
    /** 查询岗位列表 */
    getList() {
      this.loading = true;
      listPost(this.queryParams).then(response => {
        this.postList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 岗位状态字典翻译
    statusFormat(row) {
      return selectDictLabel(this.statusOptions, row.status);
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        postId: undefined,
        postCode: undefined,
        postName: undefined,
        postSort: 0,
        status: '0',
        remark: undefined
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm');
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.postId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = '添加岗位';
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const postId = row.postId || this.ids;
      getPost(postId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = '修改岗位';
      });
    },
    /** 提交按钮 */
    submitForm: function() {
      (this.$refs['form'] as ElForm).validate(valid => {
        if (valid) {
          if (this.form.postId != undefined) {
            updatePost(this.form).then(() => {
              msgSuccess('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            addPost(this.form).then(() => {
              msgSuccess('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const postIds = row.postId || this.ids;
      this.$confirm('是否确认删除岗位编号为"' + postIds + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return delPost(postIds);
      }).then(() => {
        this.getList();
        msgSuccess('删除成功');
      });
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm('是否确认导出所有岗位数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return api.system.post.export.r(queryParams);
      }).then(value => {
        download(value);
      });
    }
  }
});
